import React from 'react'

import {FieldViewProps} from "../../../../../render/view"

// const debug = "FieldProjectStatus_GlistView"
const debug = false

export default function FieldProjectStatus_GlistView(props:FieldViewProps) {

    const value  = props.field.getValue(props.model)
    const option = props.field._getOption(value)

    debug && console.log(debug, 'render', option)

    if (!option) {
        return null
    }

    return (
        <div className={Classes('ui5-status-list status-c{0}'.f(option.color), props.className)}>
            <div className="max-w-100-percent txt-truncate">{option.label}</div>
        </div>
    )
}
